import createLucideIcon from '../createLucideIcon';

const Strikethrough = createLucideIcon('StrikethroughIcon', [
  ['path', { d: 'M16 4H9a3 3 0 0 0-2.83 4', key: '43sutm' }],
  ['path', { d: 'M14 12a4 4 0 0 1 0 8H6', key: 'nlfj13' }],
  ['line', { x1: '4', y1: '12', x2: '20', y2: '12', key: '1q6rtp' }],
]);

export default Strikethrough;
